import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { formatMessage } from 'i18n/CurrentLocale';


type ReactTableNoDataComponentProps = {
    children: string,
    error: any,
}

export const ReactTableNoDataComponent = (props: ReactTableNoDataComponentProps) => {
    const noDataText = props.children;
    const { error } = props;

    return (
        noDataText && (
            <React.Fragment>
                {(error) ?
                    (
                        <ErrorRow {...props} noDataText={noDataText} />
                    ) : (
                        <NoDataRow noDataText={noDataText} />
                    )}
            </React.Fragment>
        )
    );
}

const NoDataRow = (props: { noDataText: string }) =>
    <div className="rt-noData">{props.noDataText}</div>;


type ErrorRowProps = {
    noDataText: string,
    error: any
}
const ErrorRow = (props: ErrorRowProps) => {
    return (<div className="rt-noData rt-error">
        {props.error && props.noDataText === formatMessage({ id: 'REACT_TABLE_NO_DATA_SESSIONS' }) && (
            <FormattedMessage id="ERROR_LOADING_SESSIONS" />
        )}
        {props.error && props.noDataText === formatMessage({ id: 'REACT_TABLE_NO_DATA_VEHICLES' }) && (
            <FormattedMessage id="ERROR_LOADING_VEHICLES" />
        )}
        {props.error && props.noDataText === formatMessage({ id: 'REACT_TABLE_NO_DATA_INVOICES' }) && (
            <FormattedMessage id="ERROR_LOADING_INVOICES" />
        )}

        <button className="btn-small-red" onClick={() => window.location.reload()}>
            <FontAwesomeIcon icon={faRedoAlt} className="fa-icon" />
            <FormattedMessage id="TRY_AGAIN" />
        </button>
    </div>
    );
}

export default ReactTableNoDataComponent;